import { render, staticRenderFns } from "./proxyer.vue?vue&type=template&id=a0009fb8&scoped=true&"
import script from "./proxyer.vue?vue&type=script&lang=js&"
export * from "./proxyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0009fb8",
  null
  
)

export default component.exports